import jApi from './jApi';

export default {
  getTemplateApplications(params) {
    const api = jApi.generateApi();
    return api.get('/jojolink/oos/list-application', params)
      .then(res => res.data);
  },
  getTemplateApplicationPages(params) {
    const api = jApi.generateApi();
    return api.get('/jojolink/oos/list-page-by-applications', params)
      .then(res => res.data);
  },
  installTemplateApp(params) {
    const api = jApi.generateApi();
    return api.post('/jojolink/oos/install-applications', params)
      .then(res => res.data);
  },
  installTemplatePage(params) {
    const api = jApi.generateApi();
    return api.post('/jojolink/oos/install-page', params)
      .then(res => res.data);
  },
};



// WEBPACK FOOTER //
// ./src/services/jApiTemplate.js